import React, { useState, useEffect } from 'react'
import './index.less'
import {Button, Col, FormControl, Loading, Message, Modal, Panel, PanelGroup, Row, Select, Tabs} from 'tinper-bee';
import * as util from '../../utils';
const TabPane = Tabs.TabPane;
class Limits extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
        };
    }
    async transferCreator() {
        const user_id = this.state.user_id;
        let post = {
            user_id: user_id,
            com_id: this.state.id
        };
        const res = await util.post('/package/transferCreator', post);
        this.props.refresh && this.props.refresh();
        Message.create({content: res.message, color: res.status === 200 ? 'success' :'danger'});
    }
    async quit() {
        const user_id = this.state.user_id;
        let post = {
            user_id: user_id,
            com_id: this.state.id
        };
        const res = await util.post('/package/quit', post);
        this.props.refresh && this.props.refresh();
        Message.create({content: res.message, color: res.status === 200 ? 'success' :'danger'});
    }
    async del(type, data){
        let post = {
            type,
            user_id: data.id,
            com_id: this.state.id
        }
        const res = await util.post('/package/delUser', post);
        if (res.status === 200) {
            this.getInfo(undefined, type)
            Message.create({content: '删除成功', color: 'success'});
        } else {
            Message.create({content: res.message, color: 'danger'});
        }
    }
    async editIdentity(type, data){
        let post = {
            type,
            user_id: data.id,
            com_id: this.state.id
        }
        const res = await util.post('/package/editIdentity', post);
        if (res.status === 200) {
            this.getInfo()
            Message.create({content: res.message, color: 'success'});
        } else {
            Message.create({content: res.message, color: 'danger'});
        }
    }
    async componentWillReceiveProps(nextProps) {
        if(nextProps.id !== this.state.id) {
            this.setState({id: nextProps.id})
            this.getInfo(nextProps.id)
        }
    }
    async getInfo(id?, type?) {
        if(!id) id = this.state.id;
        let {activeKey} = this.state;
        const res: any = await util.get(`/package/limits?id=${id}`);
        if(res.status === 200) {
            this.setState({
                developInfo: res.data.developInfo ||[],
                adminInfo:  res.data.adminInfo ||[],
                identity: res.data.identity,
                id
            })
            if(activeKey === 'admin' ){
                if(res.data.adminInfo.length > 0) {
                    activeKey = 'admin';
                } else {
                    activeKey = 'develop'
                }
            } else if(activeKey === 'develop'){
                if(res.data.developInfo.length > 0){
                    activeKey = 'develop'
                } else {
                    activeKey = 'admin';
                }
            } else {
                res.data.adminInfo.length > 0 ? activeKey = 'admin' : activeKey = 'develop';
            }
            this.setState({activeKey})
        }
    }
    async getUserList(){
        const list: any = await util.get('/user/list');
        this.setState({userList: list.data})
    }
    async componentDidMount() {
        const id = this.props.id;
        this.getInfo(id)
        this.getUserList();
    }
    renderModalList = data => {
        const {addOrTransfer} = this.state
        const options = data.map(item => {
            return <Select.Option value={item.id + '&' + item.name + item.email + item.phone + item.other}>{item.name}</Select.Option>;
        });
        return <React.Fragment>
            {
                addOrTransfer === 'add'
                    ?
                    <Row className='edit-row'>
                        <Col md={3} xs={3} sm={3}><span>选择身份:</span></Col>
                        <Col md={6} xs={6} sm={6}><Select
                            value={this.state.selectIdentity}
                            style={{width: 200, marginRight: 6}}
                            onChange={(e) => this.setState({selectIdentity: e})}
                            showSearch
                            allowClear
                        >
                            <Select.Option value={'admin'}>管理员</Select.Option>
                            <Select.Option value={'develop'}>开发人员</Select.Option>
                        </Select></Col>
                    </Row>
                    : null
            }
            <Row className='edit-row'>
                <Col md={3} xs={3} sm={3}><span>选择用户:</span></Col>
                <Col md={6} xs={6} sm={6}>
                    <Select
                        value={this.state.user_id}
                        style={{width: 200, marginRight: 6}}
                        onChange={(e) => {
                            this.setState({user_id: e})
                        }}
                        showSearch
                        allowClear
                    >
                        {options}
                    </Select>
                </Col>
            </Row>
        </React.Fragment>;
    }
    onCancel(){
       this.setState({modalVisible: false})
    }
    async onConfirm(){
        this.setState({modalVisible: false})
        let post: any = {};
        let res: any;
        const {user_id, addOrTransfer, selectIdentity} = this.state
        if(addOrTransfer === 'add') {
            post= {
                com_id: this.state.id,
                user_id: user_id.split('&')[0],
                identity: selectIdentity
            };
            res = await util.post('/package/addUser', post);
            this.getInfo();
            Message.create({content: res.message, color: res.status === 200 ? 'success' : 'danger'});
        } else {
            this.transferCreator();
        }
        this.setState({modalVisible: false});
    }
    render() {
        const {limitId, visible} = this.props;
        const {activeKey, identity = '',adminInfo = [], developInfo = [], userList = [], addOrTransfer} = this.state;
        return (
            <div>
                <Modal dialogClassName='org-select-modal' show={this.state.modalVisible} className="demo3-modal">
                    <Modal.Header>
                        <Modal.Title>{addOrTransfer === 'add' ? '邀请加入' : '转让创建者'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {!userList.length ? '暂无用户' : this.renderModalList(userList)}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button style={{marginRight: 10}} onClick={() => this.onCancel()}>取消</Button>
                        <Button colors={'primary'} onClick={() => this.onConfirm()}>确定</Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show = { visible }
                    onHide = { () => this.setState({userVisible: false}) } >
                    <Modal.Header closeButtonProps={{fieldId:'closeBtn'}}>
                        <Modal.Title>权限管理</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{
                            padding: '0 20px 10px',
                            textAlign: 'right'
                        }}>
                            {
                                identity === 'creator' ? <Button
                                    style={{marginRight: 5}}
                                    onClick={() => {
                                    this.setState({
                                        modalVisible: true,
                                        addOrTransfer: 'transfer'
                                    })}
                                }>转让创建者</Button> : <Button
                                    style={{marginRight: 5}}
                                    onClick={()=> this.quit()}
                                >退出团队</Button>
                            }
                            {
                                identity !== 'develop' ? <Button onClick={() => {
                                this.setState({
                                    modalVisible: true,
                                    addOrTransfer: 'add'
                                })}
                                }>邀请</Button> : null
                            }
                        </div>
                        {
                            developInfo.length > 0 || adminInfo.length > 0
                                ?
                                <Tabs
                                    activeKey={activeKey}
                                    onTabClick={(key) => this.setState({activeKey: key})}
                                >
                                    {
                                        adminInfo.length > 0 ?
                                            <TabPane tab='管理员' key="admin">
                                                <PanelGroup activeKey={this.state.passTaskActive} onSelect={(e) => this.setState({passTaskActive: e})} accordion>
                                                    {
                                                        adminInfo.map((item, index) => {
                                                            return (
                                                                <Panel header={item.name} eventKey={index}>
                                                                    <ul>
                                                                        <li><span className='info-list'>姓名：</span>{item.name}</li>
                                                                        <li><span className='info-list'>联系方式：</span>{item.email || item.phone}</li>
                                                                    </ul>
                                                                    {
                                                                        identity === 'creator' ?
                                                                            <div style={{padding: "10px 30px", textAlign: "right"}}>
                                                                                <Button style={{marginRight: '15px'}} colors={'primary'}
                                                                                        onClick={() => this.editIdentity('rollbackDevelop', item)}>降级到普通开发</Button>
                                                                                <Button
                                                                                    onClick={() => this.del('admin', item)}>删除管理员</Button>
                                                                            </div>
                                                                            :
                                                                            null
                                                                    }
                                                                </Panel>
                                                            );
                                                        })
                                                    }
                                                </PanelGroup>
                                            </TabPane>
                                            :
                                            null
                                    }
                                    {
                                        developInfo.length > 0 ?
                                            <TabPane tab={<div>开发人员</div>} key="develop">
                                                <PanelGroup activeKey={this.state.rejectTaskActive} onSelect={(e) => this.setState({rejectTaskActive: e})} accordion>
                                                    {
                                                        developInfo.map((item, index) => {
                                                            return (
                                                                <Panel header={item.name} eventKey={index}>
                                                                    <ul>
                                                                        <li><span className='info-list'>姓名：</span>{item.name}</li>
                                                                        <li><span className='info-list'>联系方式：</span>{item.email || item.phone}</li>
                                                                    </ul>
                                                                    {
                                                                        identity === 'creator' || identity === 'admin'  ?
                                                                            <div style={{padding: "10px 30px", textAlign: "right"}}>
                                                                                {
                                                                                    identity === 'creator' ? <Button style={{marginRight: '15px'}} colors={'primary'}
                                                                                                                     onClick={() => this.editIdentity('promoteAdmin', item)}>提升到管理员</Button>
                                                                                        :null
                                                                                }
                                                                                {
                                                                                    identity !== 'develop' ? <Button onClick={() => this.del('develop', item)}>删除开发人员</Button> : null
                                                                                }
                                                                            </div>
                                                                            : null
                                                                    }

                                                                </Panel>
                                                            );
                                                        })
                                                    }
                                                </PanelGroup>
                                            </TabPane> : null
                                    }
                                </Tabs> :
                                <div style={{
                                    padding: '60px',
                                    textAlign: 'center'
                                }}>没有其他人参与维护</div>
                        }

                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={ () => this.props.refresh && this.props.refresh() } colors="secondary" style={{marginRight: 8}}>取消</Button>
                        <Button onClick={ () => this.props.refresh && this.props.refresh()}  colors={'primary'}>确认</Button>
                    </Modal.Footer>
                </Modal>
            </div>

        )
    }
}
export default Limits
